import React, { Component } from 'react';
import './ProductCardStyles.css'

class ProductCard extends Component {

    render() {
        if (!this.props.obj) {
            return <h4>Loading</h4>
        }
        return (
            <article className="product-card main-shadow">
                {
                    (this.props.obj.hot) && <div className="badge bg-main">Hot</div>
                }
                <div className="product-tumb">
                    <img src={this.props.obj.img} alt="" />
                </div>
                <div className="product-details" >
                    <span className="product-catagory">{this.props.obj.category}</span>
                    <h4><a href="#name">{this.props.obj.name}</a></h4>
                    <p>{this.props.obj.description}</p>
                    <div className="product-bottom-details">
                        <div className=" product-price txt-main"><small>Rs.{this.props.obj.priceOld}.00</small>RS.{this.props.obj.priceNew}.00</div>
                        <div className="product-links">
                            <a href="#name"><i className="fa fa-heart" /></a>
                            <a href="#name"><i className="fa fa-shopping-cart" /></a>
                        </div>

                    </div>
                    <button className=" btn bg-main text-white col-12"
                        onClick={() => {
                            window.location.href = "/product"
                        }}
                    > More Info</button>
                </div>
            </article >

        );
    }
}

export default ProductCard;
